export const authRequestHandler = (request, storeInstance) => {
  if (request.method?.toUpperCase() === 'OPTIONS') return request;

  if (request._isRefreshRequest) return request;

  if (request.middleware?.withAuth && storeInstance) {
    const token = storeInstance.getState().users.token;
    if (token) {
      request.headers = {
        ...request.headers,
        Authorization: `Bearer ${token}`,
      };
    }
  }

  return request;
};